var $db24ba43c8d652ee$exports = {};
$db24ba43c8d652ee$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "".concat(args.item, " ikke valgt.");
  },
  "longPressToSelect": "Lav et langt tryk for at aktivere valgtilstand.",
  "select": "V\xE6lg",
  "selectedAll": "Alle elementer valgt.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Ingen elementer valgt",
      one: function one() {
        return "".concat(formatter.number(args.count), " element valgt");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " elementer valgt");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "".concat(args.item, " valgt.");
  }
};
export { $db24ba43c8d652ee$exports as default };